import {omit} from "@pg-mono/nodash";

import {getOfferListSortName} from "../../helpers/get_offer_list_sort_name";
import {OfferType} from "../../types/OfferType";
import {OFFER_LIST_CONSTRAINTS, OFFER_LIST_PAGE_SIZE} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";
import {getValidOfferListQuery, ValidOfferListQuery} from "./validate_offer_list_query";

export const getFetchOfferListQueryData = (query: Record<string, string | string[] | null | boolean>, isPresale?: boolean) => {
    const isPromotionsTab = isPromotionsListingQuery(query);
    const validatedQuery = getValidOfferListQuery(query);

    const intPage = parseInt(validatedQuery.page as string, 10);
    const paramPage = isNaN(intPage) ? 1 : intPage;
    // "s" query param clashes with scenario parameter when searching Google Places
    const safeQuery = omit(validatedQuery, ["s"]);

    const fullQuery: ValidOfferListQuery = {
        ...safeQuery,
        ...(safeQuery.type == null ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
        ...OFFER_LIST_CONSTRAINTS,
        sort: getOfferListSortName(safeQuery.sort as SearchSortString),
        page_size: OFFER_LIST_PAGE_SIZE,
        page: paramPage,
        ...(safeQuery.price_lower_than_average ? {price_lower_than_average: 1} : {}), // enable "tanie" filter, when upper price query is lower than average price per m2 for selected region
        ...(isPresale ? {include_pre_sale: "true"} : {}),
        ...(isPromotionsTab ? {unique_promotions: "true", with_promotions: "true"} : {})
    };

    return {fullQuery, paramPage, safeQuery};
};

export const getFetchOfferListPropertiesCountQuery = (query: Record<string, string | string[] | null | boolean>) => {
    const {fullQuery} = getFetchOfferListQueryData(query, true);

    return omit(fullQuery, ["page", "page_size", "sort"]);
};

export const getFetchOfferListPromotionalOffersCountQuery = (fullQuery: ValidOfferListQuery) => ({
    ...omit(fullQuery, ["page", "page_size", "sort"]),
    unique_promotions: "true",
    with_promotions: "true"
});
import {omit} from "@pg-mono/nodash";

import {getOfferListSortName} from "../../helpers/get_offer_list_sort_name";
import {OfferType} from "../../types/OfferType";
import {OFFER_LIST_CONSTRAINTS, OFFER_LIST_PAGE_SIZE} from "../constants/offer_list";
import {SearchSortString} from "../constants/SearchSort";
import {isPromotionsListingQuery} from "./map_offer_list_promotions_query_param";
import {getValidOfferListQuery, ValidOfferListQuery} from "./validate_offer_list_query";

export const getFetchOfferListQueryData = (query: Record<string, string | string[] | null | boolean>, isPresale?: boolean) => {
    const isPromotionsTab = isPromotionsListingQuery(query);
    const validatedQuery = getValidOfferListQuery(query);

    const intPage = parseInt(validatedQuery.page as string, 10);
    const paramPage = isNaN(intPage) ? 1 : intPage;
    // "s" query param clashes with scenario parameter when searching Google Places
    const safeQuery = omit(validatedQuery, ["s"]);

    const fullQuery: ValidOfferListQuery = {
        ...safeQuery,
        ...(safeQuery.type == null ? {type: [OfferType.FLAT, OfferType.HOUSE]} : {}),
        ...OFFER_LIST_CONSTRAINTS,
        sort: getOfferListSortName(safeQuery.sort as SearchSortString),
        page_size: OFFER_LIST_PAGE_SIZE,
        page: paramPage,
        ...(safeQuery.price_lower_than_average ? {price_lower_than_average: 1} : {}), // enable "tanie" filter, when upper price query is lower than average price per m2 for selected region
        ...(isPresale ? {include_pre_sale: "true"} : {}),
        ...(isPromotionsTab ? {unique_promotions: "true", with_promotions: "true"} : {})
    };

    return {fullQuery, paramPage, safeQuery};
};

export const getFetchOfferListPropertiesCountQuery = (query: Record<string, string | string[] | null | boolean>) => {
    const {fullQuery} = getFetchOfferListQueryData(query, true);

    return omit(fullQuery, ["page", "page_size", "sort"]);
};

export const getFetchOfferListPromotionalOffersCountQuery = (fullQuery: ValidOfferListQuery) => ({
    ...omit(fullQuery, ["page", "page_size", "sort"]),
    unique_promotions: "true",
    with_promotions: "true"
});
